
import { CompartMeasurementPonitsViewModel, CompartViewModel, MeasurementToolsViewModel, CreateMeasurementPointModel, UpdateAllCalculationMethods, WSREMeasurementPoints, CopyObsPointModel } from "../model/measurement-points.model";
import { CompartType, Tuple, SearchItem, SearchItemsParam, SelectedList, CompartDealerList } from "../../../entities";
import { Injectable } from '@angular/core';
import { HttpParams, HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { Observable } from 'rxjs/Observable';
import { of } from "rxjs/observable/of";

@Injectable()
export class MeasurementPonitsService {
  
    private readonly COMPARTLISTAPI = "Api/Component/getAvailableCompartTypeList";
    private readonly COMPARTMEASUREMENTPOINTSAPI = "Api/Component/getComponentAndMeasurementPoints";
    private readonly COMPARTWITHMEASUREMENTPOINTCONFIGED = "Api/Component/GetCompartHasMeasurementPointsConfigured";
    private readonly MEASUREMENTTOOLS = "Api/Component/GetAllMeasurementTools";   
    private readonly CREATENEWMEASUREMENTPOINTS = "Api/Component/CreateNewMeasurementPoint";
    private readonly Update_New_MeasurementPoint = "Api/Component/UpdateNewMeasurementPoint";

    
    private readonly CHANGEMEASUREMENTPOINTSACTIVESTATUS = "Api/Component/ChangeMeasurementPointActiveStatus";


    private readonly UPDATEMEASUREMENTPOINTSCALCULATIONS = "Api/Component/UpdateMeasurementPoints";
    private readonly UPDATE_COMPART_CONTRIBUTE_PERCENTAGE = "Api/Components/UpdateCompartContributePercentage";
    private readonly WSREMeasurmentPointURL = "Api/Component/getWSREMeasurmentPoint";
    private readonly WSREMeasurmentPointFrameURL = "Api/Component/getWSREMeasurmentPointFrame";
    private readonly GETCompartLinkedModels = "Api/Component/GETCompartLinkedModels";

    private readonly AddNewWSRESubComponent = "Api/Component/AddNewWSRESubComponent";
    private readonly OrderUpForWSRESubComponent = "Api/Component/OrderUpForWSRESubComponent";
    private readonly OrderDownForWSRESubComponent = "Api/Component/OrderDownForWSRESubComponent";
    private readonly OrderUpForMeasurementPoint = "Api/Component/OrderUpForMeasurementPoint";
    private readonly OrderDownForMeasurementPoint = "Api/Component/OrderDownForMeasurementPoint";
    private readonly COPYOBSPOINTS = "Api/Component/CopyObsPoints";

    constructor(private _http: HttpClient) { }

    getWSREMeasurmentPoint(CompartId : number){
      let options = {
        params: new HttpParams().set('CompartId', CompartId.toString())
      };
      return this._http.get<WSREMeasurementPoints[]>(this.WSREMeasurmentPointURL,options).pipe(catchError(this.errorHandler<WSREMeasurementPoints[]>()));    
    }
    getWSREMeasurmentPointForFrame(CompartId : number){
      let options = {
        params: new HttpParams().set('CompartId', CompartId.toString())
      };
      return this._http.get<WSREMeasurementPoints[]>(this.WSREMeasurmentPointFrameURL,options).pipe(catchError(this.errorHandler<WSREMeasurementPoints[]>()));    
    }


    AddWSRESubComponent(Name : string){
      let options = {
        params: new HttpParams().set('Name', Name)
      };
      return this._http.get<boolean>(this.AddNewWSRESubComponent,options).pipe(catchError(this.errorHandler<boolean>()));    
    }

    public OrderUp_WSRESubComponent(SubCompId:number ,Order:number)  {
      const options = {
        params: new HttpParams().set('SubCompId', SubCompId.toString()).set('Order', Order.toString())
      };
    return this._http.get(this.OrderUpForWSRESubComponent, options).pipe(catchError(this.handleError));
    
    }
    
    public OrderDown_WSRESubComponent(SubCompId:number ,Order:number)  {
      const options = {
        params: new HttpParams().set('SubCompId', SubCompId.toString()).set('Order', Order.toString())
      };
    return this._http.get(this.OrderDownForWSRESubComponent, options).pipe(catchError(this.handleError));
    
    }

    public OrderUp_MeasurementPoint(compId:number ,Order:number, swapid:number, name:string)  {
      const options = {
        params: new HttpParams().set('CompId', compId.toString()).set('Order', Order.toString()).set('SwapId', swapid.toString()).set('Name', name)
      };
      return this._http.get<boolean>(this.OrderUpForMeasurementPoint, options).pipe(catchError(this.handleError));
    }
    
    public OrderDown_MeasurementPoint(compId:number ,Order:number, swapid:number, name:string)  {
      const options = {
        params: new HttpParams().set('CompId', compId.toString()).set('Order', Order.toString()).set('SwapId', swapid.toString()).set('Name', name)
      };
      return this._http.get<boolean>(this.OrderDownForMeasurementPoint, options).pipe(catchError(this.handleError));
    }

    getCompartLinkedModels(CompartId : number){
      let options = {
        params: new HttpParams().set('CompartId', CompartId.toString())
      };
      return this._http.get<WSREMeasurementPoints[]>(this.GETCompartLinkedModels,options).pipe(catchError(this.errorHandler<WSREMeasurementPoints[]>()));    
    }


    getCompartMeasurementPoints(compartId : number){
      let options = {
        params: new HttpParams().set('compartId', compartId.toString())
      };
      return this._http.get<CompartMeasurementPonitsViewModel>(this.COMPARTMEASUREMENTPOINTSAPI, options).pipe(catchError(this.errorHandler<CompartMeasurementPonitsViewModel>()));
    }


    getCompartMeasurementPointsNew(compartId : number,typeid:number, modelId:number){
      if(typeid==undefined){
typeid=0;
      }
      let options = {
        params: new HttpParams().set('CompartId', compartId.toString())
        .set('DealerGroupId', typeid.toString()).set('ModelId', modelId.toString())
      };
      return this._http.get<CompartMeasurementPonitsViewModel>(this.COMPARTMEASUREMENTPOINTSAPI, options).pipe(catchError(this.errorHandler<CompartMeasurementPonitsViewModel>()));
    }
    

    getCompartList(): Observable<CompartType[]>{
      return this._http.get<CompartType[]>(this.COMPARTLISTAPI).pipe(catchError(this.errorHandler<CompartType[]>()));
    }

    getComponentsByType(TypeId : number){

    }


    getCompartsWithMeasurementPointsConfiged(){
      return this._http.get<CompartViewModel[]>(this.COMPARTWITHMEASUREMENTPOINTCONFIGED).pipe(catchError(this.errorHandler<CompartViewModel[]>()));    
    }



    getMeasurementTools(){
      return this._http.get<MeasurementToolsViewModel[]>(this.MEASUREMENTTOOLS).pipe(catchError(this.errorHandler<MeasurementToolsViewModel[]>()));    
    }

    updateMeasurementPointsCalculations(model: UpdateAllCalculationMethods): Observable<Tuple> {
      return this._http.post<Tuple>(this.UPDATEMEASUREMENTPOINTSCALCULATIONS, model).pipe(catchError(this.handleError));    
    
    }

    UpdateNewMeasurementPoint(newModel : CreateMeasurementPointModel): Observable<Tuple>{
      return this._http.post<Tuple>(this.Update_New_MeasurementPoint, newModel).pipe(catchError(this.handleError));    
    }
    
    

    GetMeasurementPointImage(measurementPonitsId:number){
      let options = {
        params: new HttpParams().set('measurementPonitsId',measurementPonitsId.toString())
      };
      return this._http.get('Api/Application/getMeasurementPointsImage', options).pipe(catchError(this.handleError));
    }
    
    createNewMeasurementPoint(newModel : CreateMeasurementPointModel): Observable<Tuple>{
      return this._http.post<Tuple>(this.CREATENEWMEASUREMENTPOINTS, newModel).pipe(catchError(this.handleError));    
    }

    UpdateContributionForCompartPercentage(compartId:number, modelId:number, percentage:number){
      let options = {
        params: new HttpParams().set('compartId',compartId.toString()).set('modelId', modelId.toString()).set('percentage', percentage.toString())
      };

      return this._http.get(this.UPDATE_COMPART_CONTRIBUTE_PERCENTAGE, options).pipe(catchError(this.handleError));
    }

    UpdateContributionForMeasurementPointPercentage(MeasurementPonitId:number,  percentage:number){
      let options = {
        params: new HttpParams().set('MeasurementPonitId',MeasurementPonitId.toString()).set('percentage', percentage.toString())
      };

      return this._http.get("Api/Components/UpdateMeasurementPointContributePercentage", options).pipe(catchError(this.handleError));
    }
    
    
    changeMeasurementPointStatus(status: boolean, measurementPointId : number) :Observable<Tuple>{
      let options = {
        params: new HttpParams().set('status',status.toString()).set('measurementPointId', measurementPointId.toString())
      };

      return this._http.get<Tuple>(this.CHANGEMEASUREMENTPOINTSACTIVESTATUS, options).pipe(catchError(this.handleError));
    }


    getFilteredComparts(SearchItems: SearchItem[], TypeId:number): Observable<CompartViewModel[]>{
      let params: SearchItemsParam = new SearchItemsParam();   
      params.SearchItems = SearchItems;
      params.typeId=TypeId;
      return this._http.post<CompartViewModel[]>("Api/Components/getComponentsViewListBySearchItems", params).pipe(catchError(this.errorHandler<CompartViewModel[]>()));
    }


    public getFilteredCompartsByModel(ModelId:number): Observable<CompartViewModel[]> {
      const options = {
        params: new HttpParams().set('ModelId', ModelId.toString())
      };
      return this._http.get<CompartViewModel[]>("Api/Components/getComponentsViewListByModelId", options).pipe(catchError(this.handleError));
    }
    private errorHandler<T>(operation = "operation", result? :T){
      return (error :any) : Observable<T> => {
        console.log(error);
        return of(result as T);
      }
    }

    // public isMeasurementPointNameExist(measurementPointName:string): Observable<boolean> {
    //   const options = {
    //     params: new HttpParams().set('measurementPointName', measurementPointName.toString())
    //   };
    //   return this._http.get("Api/Component/isMeasurementPointNameExist", options).pipe(catchError(this.handleError));
    // }

    isMeasurementPointNameExist(newModel : CreateMeasurementPointModel): Observable<any>{
      return this._http.post<CreateMeasurementPointModel>('Api/Component/isMeasurementPointNameExist', newModel).pipe(catchError(this.handleError));    
    }
    private handleError(error: Response) {
       
      return Observable.throw(error.json() || 'Server error');
  }

  CopyObsPoints(newModel : CompartDealerList): Observable<number>{
    return this._http.post<number>(this.COPYOBSPOINTS, newModel).pipe(catchError(this.handleError));    
  }

  GetComponentsByModel(modelId:number, comparttypeid:number): Observable<CompartViewModel[]>{
    const options = {
      params: new HttpParams().set('modelid', modelId.toString()).set('compartTypeId', comparttypeid.toString())
    };
    return this._http.get<CompartViewModel[]>("Api/Component/GetComponentsByModel", options).pipe(catchError(this.handleError));
  }
}